import React, {useEffect, useRef, useState} from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';
import InputAdornment from '@mui/material/InputAdornment';
import SaveIcon from '@mui/icons-material/Save';
import { CurrencyShekel } from 'tabler-icons-react';
import IItem from "../../../../../types/product_delivery";

interface IProduct {
    name: string;
    barcode: string;
    image?: string;
    id: string;
}

interface ICustomerProductsSingleRowProps {
    data: IItem[];
    setData: any;
    setIsAnySelected: (selected: boolean) => void;
    setPriceChanges?:any
}

// BUGGED! TEXT FIELDS ARE POORLY HANDLED

const PricesListSingleRowComponent: React.FC<ICustomerProductsSingleRowProps> = ({ data, setData, setIsAnySelected,setPriceChanges }) => {

    const [selectedItems, setSelectedItems] = useState<Record<string, boolean>>({});

    // Store debounce timers for each product.id
    const debounceTimersRef = useRef<Record<string, NodeJS.Timeout>>({});

    const handleCheckboxChange = (id: number) => {
        setSelectedItems((prev) => ({ ...prev, [id]: !prev[id] }));
    };

    useEffect(() => {
        const isAnySelected = Object.values(selectedItems).some(Boolean);
        setIsAnySelected(isAnySelected);
    }, [selectedItems]);

    const debounceUpdate = (curItem, update: Partial<IItem>) => {
        const id = curItem.id;

        // Clear any existing timeout
        if (debounceTimersRef.current[id]) {
            clearTimeout(debounceTimersRef.current[id]);
        }

        debounceTimersRef.current[id] = setTimeout(() => {
            // Update `setData`
            setData((prevData: IItem[]) =>
                prevData.map((item) =>
                    item.id === id ? { ...item, ...update } : item
                )
            );

            // Update `setPriceChanges`
            if (setPriceChanges) {
                setPriceChanges((prev: IItem[]) => {
                    const updated = [...prev];
                    const index = updated.findIndex((i) => i.id === id);
                    if (index !== -1) {
                        updated[index] = { ...updated[index], ...update };
                    } else {
                        updated.push({ ...curItem, ...update });
                    }
                    return updated;
                });
            }

            // Clean up the timer
            delete debounceTimersRef.current[id];
        }, 1000); // 1 second debounce
    };

    const handlePriceChange = (curItem: IItem, price: number | null) => {
        debounceUpdate(curItem, { totalPrice: price });
    };

    const handleDiscountChange = (curItem: IItem, discount: number | null) => {
        debounceUpdate(curItem, { discount });
    };
    return (
        <>
            {data.map((product) => {
                const price = product.totalPrice
                const discount = product.discount
                const total = price - price * (discount / 100);

                return (
                    <Box
                        key={product.id}
                        sx={{
                            display: 'flex',
                            width: '100%',
                            flexDirection: 'row',
                            alignItems: 'center',
                            gap: '8px',
                            boxShadow: 1,
                            backgroundColor: 'grey.100',
                            padding: 1,
                            borderRadius: '0px',
                            marginBottom: 0,
                            whiteSpace: 'normal',
                            wordBreak: 'break-word'
                        }}
                    >
                        <Checkbox
                            size="small"
                            sx={{ padding: 0, width: '10px', height: '10px' }}
                            checked={Boolean(selectedItems[product.id])}
                            onChange={() => handleCheckboxChange(product.id)}
                        />
                        <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%', maxWidth: '75px', whiteSpace: 'normal' }}>
                            <Typography sx={{ fontSize: '13px', color: 'black' }}>{product.name}</Typography>
                            <Typography sx={{ fontSize: '10px', color: 'black' }}>{product.barcode}</Typography>
                        </Box>
                        {/* Price Input */}
                        <Box sx={{ display: 'flex', flexDirection: 'column', width: '60px' }}>
                            <Typography sx={{ fontSize: '10px', color: 'black' }}>מחיר</Typography>
                            <TextField
                                type="number"
                                variant="standard"
                                size="small"
                                defaultValue={price } // Use empty string if null

                                onChange={(e) => handlePriceChange(product, parseFloat(e.target.value) || 0)}
                                placeholder="מחיר"
                                onFocus={(e) => e.target.select()} // Select all text when focused
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end" sx={{ width: '15px', height: '15px' }}>
                                            <CurrencyShekel fontSize="small" />
                                        </InputAdornment>
                                    )
                                }}
                            />
                        </Box>
                        {/* Discount Input */}
                        <Box sx={{ display: 'flex', flexDirection: 'column', width: '60px' }}>
                            <Typography sx={{ fontSize: '10px', color: 'black' }}>הנחה(%)</Typography>
                            <TextField
                                type="number"
                                variant="standard"
                                size="small"
                                defaultValue={discount}
                                onChange={(e) => handleDiscountChange(product, parseFloat(e.target.value) || 0)}
                                placeholder="הנחה(%)"
                                onFocus={(e) => e.target.select()} // Select all text when focused
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end" sx={{ width: '15px', height: '15px' }}>
                                            %
                                        </InputAdornment>
                                    )
                                }}
                            />
                        </Box>
                        {/* Total Input */}
                        <Box sx={{ display: 'flex', flexDirection: 'column', width: '100px' }}>
                            <Typography sx={{ fontSize: '10px', color: 'black' }}>סה״כ</Typography>
                            <TextField
                                type="number"
                                variant="standard"
                                size="small"
                                sx={{ maxWidth: '80px' }}
                                value={total.toFixed(2)}
                                placeholder="סה״כ"
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end" sx={{ width: '15px', height: '15px' }}>
                                            <CurrencyShekel fontSize="small" />
                                        </InputAdornment>
                                    )
                                }}
                                disabled
                            />
                        </Box>
                        {/*<IconButton sx={{ fontSize: 10, margin: 'auto' }}>*/}
                        {/*    <SaveIcon fontSize="small" />*/}
                        {/*</IconButton>*/}
                    </Box>
                );
            })}
        </>
    );
};

export default PricesListSingleRowComponent;
